__turbopack_context__.v({
  "ClearIcon": "xM2DWG_ClearIcon",
  "ClearIndicator": "xM2DWG_ClearIndicator",
  "Date": "xM2DWG_Date",
  "IconLeft": "xM2DWG_IconLeft",
  "IconRight": "xM2DWG_IconRight",
  "IconTextWrapper": "xM2DWG_IconTextWrapper",
  "Image": "xM2DWG_Image",
  "Menu": "xM2DWG_Menu",
  "MenuList": "xM2DWG_MenuList",
  "Root": "xM2DWG_Root",
  "SelectControl": "xM2DWG_SelectControl",
  "SelectControl--HasBorder": "xM2DWG_SelectControl--HasBorder",
  "SelectControl--IsFocused": "xM2DWG_SelectControl--IsFocused",
  "SelectControl--IsMenuOpened": "xM2DWG_SelectControl--IsMenuOpened",
  "SelectControl--WhiteBackground": "xM2DWG_SelectControl--WhiteBackground",
  "SelectDropdownIndicator": "xM2DWG_SelectDropdownIndicator",
  "SelectDropdownIndicator--IsMenuOpen": "xM2DWG_SelectDropdownIndicator--IsMenuOpen",
  "SelectInput": "xM2DWG_SelectInput",
  "SelectNoOptionsMessage": "xM2DWG_SelectNoOptionsMessage",
  "SelectOption": "xM2DWG_SelectOption",
  "SelectOption--IsSelected": "xM2DWG_SelectOption--IsSelected",
  "SelectOptionWithImage": "xM2DWG_SelectOptionWithImage",
  "SelectPlaceholder": "xM2DWG_SelectPlaceholder",
  "SelectSingleValue": "xM2DWG_SelectSingleValue",
  "Text": "xM2DWG_Text",
  "Title": "xM2DWG_Title",
  "skeleton-loading": "xM2DWG_skeleton-loading",
});
